var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"prz-blk-social-likes-box"},[(_vm.likes && _vm.showNumber)?_c('span',{staticClass:"prz-blk-product-likes-num"},[_vm._v(_vm._s(_vm.likes))]):_vm._e(),_c('span',{staticClass:"prz-blk-product-likes-icon"},[_c('prz-likes',{attrs:{"info":_vm.info,"count":_vm.likes},on:{"change":_vm.change}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }